import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=7dbb61d3&"
var script = {}
import style0 from "./Download.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports